import { __assign } from "tslib";
var AnalyticsEvent = /** @class */ (function () {
    function AnalyticsEvent(props) {
        var _this = this;
        this.clone = function () {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = __assign({}, _this.payload);
            return new AnalyticsEvent({ payload: payload });
        };
        this.payload = props.payload;
    }
    AnalyticsEvent.prototype.update = function (updater) {
        if (typeof updater === 'function') {
            this.payload = updater(this.payload);
        }
        if (typeof updater === 'object') {
            this.payload = __assign(__assign({}, this.payload), updater);
        }
        return this;
    };
    return AnalyticsEvent;
}());
export default AnalyticsEvent;
//# sourceMappingURL=AnalyticsEvent.js.map